import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {entityConfigFeatureKey, reducer} from './entity-configuracao.reducer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(entityConfigFeatureKey, reducer),
  ],
})
export class EntityConfiguracaoModule {
}
